import { render, staticRenderFns } from "./SalaryDetail.vue?vue&type=template&id=465f602e&scoped=true&"
import script from "./SalaryDetail.vue?vue&type=script&lang=js&"
export * from "./SalaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalaryDetail.vue?vue&type=style&index=0&id=465f602e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f602e",
  null
  
)

export default component.exports